var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "holiday-alert-wrap" },
    [
      _c(
        "el-alert",
        {
          staticClass: "holiday-alert",
          attrs: { type: "warning", "show-icon": "" }
        },
        [
          _c(
            "p",
            {
              staticClass: "holiday-alert-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _vm._v("\n\t\t\t\t工单服务国庆中秋假期放假安排："),
              _c("br"),
              _vm._v(
                "\n国庆中秋假期将至，2020年10月1日至10月8日期间，讯飞开放平台将继续为您提供服务支持。节假日期间，您可以通过拨打客服电话：4000199199（8:30～22:00，全年无休）与我们联络，其他渠道的服务将于10月9日起恢复正常。给您带来的不便敬请谅解，感谢您的支持！\n讯飞开放平台全体工作人员祝您国庆中秋双节快乐！\n\t\t\t"
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-476bdaac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476bdaac","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/HolidayAlert/NationalDay.vue
// module id = 759
// module chunks = 40